<template>
  <div>
    <div style="padding: 10px; background-color: white; border-radius: 4px">
      <cForm ref="form" :fields="fields" :grid="grid" :config="config"></cForm>
    </div>
    <!-- <div style="padding: 10px;background-color: white;border-radius: 4px;margin-top: 20px;">
			<h4>{{$tz('货物详情')}}</h4>
			<div style="height: 10px;"></div>
			<Sku :list="list"></Sku>
		</div> -->
    <div class="action">
      <Button @click="save" type="primary">{{ $tz("提交") }}</Button>
      <!-- <Button @click="upload" type="primary" style="margin-left: 10px">{{
        $tz("批量,上传")
      }}</Button>
      <Button @click="down" type="primary" style="margin-left: 10px">{{
        $tz("下载模板")
      }}</Button> -->
    </div>
    <Modal v-model="visible" :title="$tz('上传')" footer-hide width="1000px">
      <Table height="600px" :columns="columns" :data="data"></Table>
    </Modal>
  </div>
</template>

<script>
import cForm from "@/base/common/component/form.vue";
import useFields from "./info.js";
export default {
  components: {
    cForm,
  },
  data() {
    return {
      updateKeys: {
        "Return Platform": "platform",
        "Partner ID/Store ID": "shop_ID",
        "Return tracking number": "tracking_code",
        "Treatment scheme": "plan",
        CTNS: "number",
        SKU: "sku",
        PCS: "sku_number",
        "Returned Warehouse": "warehouse_id",
        "Return time": "return_date",
        "Arrival time": "receipt_date",
      },
      columns: [],
      data: [],
      visible: false,
      fields: [],
      grid: [],
      list: [],
      config: {},
      selectData: {},
    };
  },
  mounted() {
    this.columns = [
      {
        title: this.$tz("状态"),
        width: 150,
        key: "status",
      },
      ...Object.keys(this.updateKeys).map((k) => {
        return {
          title: k,
          width: 120,
          key: k,
        };
      }),
    ];
    Object.assign(this, useFields.apply(this));
  },
  methods: {
    upload() {
      this.$refs["form"].selectFile().then((file) => {
        let num = 2;
        this.$refs["form"]
          .readFile(file[0], num)
          .then((res) => {
            let selectKeys = ["platform", "plan", "warehouse_id"];
            let dateKeys = ["return_date", "receipt_date"];
            let childKeys = ["sku"];
            let data = res.map((item, index) => {
              item.status = this.$tz("正在上传");
              return Object.keys(item).reduce((a, b) => {
                let key = this.updateKeys[b];
                let value = item[b];
                if (selectKeys.includes(key)) {
                  let item = this.selectData[key].find(
                    (t) => t.label === value
                  );
                  a[key] = item && item.value;
                } else if (dateKeys.includes(key) && value) {
                  value = value.getTime() + 86400000;
                  a[key] = this.$refs["form"].format.zoneDate(value);
                  item[b] = this.$refs["form"].format.zoneDate(value);
                } else if (childKeys.includes(key)) {
                  let sku = value.toString().split(/[，|,]/);
                  let number = item["PCS"].toString().split(/[，|,]/);
                  if (sku.length !== number.length)
                    throw this.$Message.error({
                      content: this.$tz(
                        "第{1}行：SKU和数量分行长度不一致，请检查！",
                        index + num + 2
                      ),
                      background: true,
                      duration: 5,
                    });
                  a[key] = sku.map((_, i) => ({
                    sku: sku[i],
                    sku_number: number[i],
                  }));
                } else {
                  a[key] = value;
                }
                return a;
              }, {});
            });
            console.log(res);
            this.data = res;
            this.visible = true;
            data.map((t, i) => {
              Add(t).then((res) => {
                if (res.data.status) {
                  this.data[i].status = this.$tz("成功");
                } else {
                  this.data[i].status = res.data.msg;
                }
              });
            });
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    down() {
      window.open(
        "https://portal.vnlin.com/api/static/templates/UploadPlatformReturnService.xlsx"
          .replace("static", "doc")
          .replace("templates", this.$i18n.locale)
      );
    },
    save() {
      this.$refs["form"]
        .submit(true)
        .then((data) => {
          this.submit(data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped lang="less">
.action {
  width: 100%;
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>